import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetKey: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15.5 2A5.5 5.5 0 0010 7.5c0 .88.21 1.71.58 2.45L2 18.5V22h3.5v-2H8v-2.5l2.45-.57A5.5 5.5 0 1015.5 2zm1 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
      </svg>
    </div>
  );
};

export default WidgetKey;
